import {
  RefundService,
  RefundServiceConfirmResponse,
  RefundServiceQuoteResponse,
} from "@gen/travel/v1/refund_pb";
import { client } from "./config";

export async function quoteRefund(
  travelId: string,
): Promise<RefundServiceQuoteResponse> {
  return await client(RefundService).quote({
    travelId,
  });
}

export async function confirmRefund(
  travelId: string,
): Promise<RefundServiceConfirmResponse> {
  return await client(RefundService).confirm({
    travelId,
  });
}
